import {
  CollateralAprAsset,
  makePercent,
  Percent,
  PositionReward,
} from "@silo/types";
import { Array, BigInt, pipe } from "effect";
import { byAprDesc } from "./rewards";

export interface CollateralAprMetrics {
  totalCollateralRewardsApr: Percent;
  hasCollateralRewards: boolean;
  totalCollateralApr: Percent;
  collateralRewards: PositionReward[];
}

export function getCollateralAprMetrics(
  asset: CollateralAprAsset,
  nativeRewardsSymbol: string
): CollateralAprMetrics {
  const { collateralBaseApr, collateralRewardsApr, collateralMerklRewards } =
    asset;

  const totalCollateralRewardsApr = pipe(
    [
      collateralRewardsApr,
      ...collateralMerklRewards.map((reward) => reward.apr),
    ],
    BigInt.sumAll,
    makePercent
  );

  const hasCollateralRewards = totalCollateralRewardsApr > 0n;

  const totalCollateralApr = pipe(
    collateralBaseApr + totalCollateralRewardsApr,
    makePercent
  );

  const nativeReward: PositionReward = {
    rewardTokenSymbol: nativeRewardsSymbol,
    apr: collateralRewardsApr,
    isSuperFest: false,
  };

  const collateralRewards: PositionReward[] = pipe(
    [nativeReward, ...collateralMerklRewards],
    Array.filter((reward) => reward.apr > 0n),
    Array.sort(byAprDesc)
  );

  return {
    totalCollateralRewardsApr,
    hasCollateralRewards,
    totalCollateralApr,
    collateralRewards,
  };
}
